import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage"
import axios from "axios"
import DepartmentInformation from "./department"

const DepartmentContainer = () => {
  // 
  const submitDepartmentInfo = (event, departmentInfo) => {
    event.preventDefault();
    let body = {
      ...departmentInfo,
      amount: Number(departmentInfo?.amount)
    }
    axios.post("https://arogyanxtdevapi.fundaclear.in/api/Department", body).then((res) =>{
      if(res?.status === 200){
        // navigate("/opd", { state: { addPatient: false } })
        successToast(res?.data?.message);
      }
    }).catch((err) =>{
      errorToast(err?.response?.data?.error || err?.response?.data?.message)
    })
  }

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <DepartmentInformation submitDepartmentInfo={submitDepartmentInfo} />
        </>
      </div>
    </div>
  )
}

export default DepartmentContainer